<template>
  <div class="select" @click="toggle()" @blur="close()">
    <div class="select-placeholder">
      <span>{{ selectPlaceholder }}</span>
      <i class="select-arrow icon-checvron_bottom">
        <IconChevronBottom></IconChevronBottom>
      </i>
    </div>

    <div class="select-options" v-show="focus">
      <div
        class="select-option"
        v-for="(choice, index) in choices"
        :class="[
          { 'select-option-disabled': choice.disabled },
          { 'select-option-active': currentOptions.value === choice.value },
        ]"
        :key="`${name}-${index}`"
      >
        <input
          :id="`${name}-option-${choice.value}`"
          class="select-input hidden"
          type="radio"
          :name="name"
          :value="choice"
          :disabled="choice.disabled"
          v-model="currentOptions"
        />

        <label
          :for="`${name}-option-${choice.value}`"
          class="select-option-label"
          @click="close()"
        >
          {{ choice.label }}
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import IconChevronBottom from '@/assets/icons/icon-chevron_bottom.svg'

export default {
  components: {
    IconChevronBottom,
  },

  props: {
    name: {
      type: String,
      default: '',
    },

    choices: {
      type: Array,
      default: () => [],
    },

    placeholder: {
      type: String,
      default: '',
    },

    firstOption: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      focus: false,
      currentOptions: {},
    }
  },

  computed: {
    selectPlaceholder() {
      return Object.keys(this.currentOptions).length &&
        this.currentOptions.label
        ? this.currentOptions.label
        : this.placeholder
    },
  },

  watch: {
    currentOptions(newValue) {
      this.$emit('input', newValue)
    },
  },

  created() {
    this.active()
  },

  methods: {
    toggle() {
      this.focus = !this.focus
    },

    open() {
      this.focus = true
    },

    close() {
      this.focus = false
    },

    active() {
      for (const choice of this.choices) {
        this.currentOptions = choice.active ? choice : this.currentOptions
      }
      this.currentOptions =
        !Object.keys(this.currentOptions).length && this.firstOption
          ? this.choices.filter(x => typeof x !== undefined).shift()
          : this.currentOptions
    },
  },
}
</script>
